<template>
  <div class="col-md-6">
    <div class="row">
      <div class="col-md-6 pb-4">
        <stats-card
          type="warning"
          icon="nc-icon nc-hat-3"
          small-title="Participants"
          title-class="finance-card-title"
          :title="budgetInfo.Budget.ParticipantCount + ' / ' + budgetInfo.Budget.EstimatedParticipants"
        >
          <div
            class="stats"
            slot="footer"
          >
            <i class="bi bi-people" />
            {{ budgetInfo.Budget.ParticipantsNotPaid }} not paid in full
          </div>
        </stats-card>
      </div>
      <div class="col-md-6">
        <stats-card
          type="warning"
          icon="nc-icon nc-circle-10"
          small-title="Staff Members"
          title-class="finance-card-title"
          :title="budgetInfo.Budget.StaffCount + ' / ' + budgetInfo.Budget.EstimatedStaff"
        >
          <div
            class="stats"
            slot="footer"
          >
            <i class="bi bi-person-circle" />
            {{ budgetInfo.Budget.StaffNotPaid }} have not paid fees
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 pb-4">
        <stats-card
          type="warning"
          icon="bi bi-receipt"
          small-title="Receipts Total"
          title-class="finance-card-title"
          :title="budgetSpent"
        >
          <div
            class="stats"
            slot="footer"
          >
            <i class="bi bi-pie-chart" />
            <span :class="{'text-red': (budgetInfo.Budget.ExpenseToBudget > 1)}">{{ percentBudgetSpent }}</span> spent so far
          </div>
        </stats-card>
      </div>
      <div class="col-md-6">
        <stats-card
          type="warning"
          icon="bi bi-shop"
          small-title="Remaining"
          :title-class="budgetRemainingClass"
          :title="budgetRemaining"
        >
          <div
            class="stats"
            slot="footer"
          >
            <i class="bi bi-pie-chart-fill" />
            {{ percentBudgetRemaining }} budget remaining
          </div>
        </stats-card>
      </div>
    </div>
  </div>
</template>

<script>
import statsCard from '@/plugins/paper-components/cards/stats-card'
import formatter from '@/services/formatter.js'

export default {
  name: 'BudgetStatistics',
  props: {
    budgetInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    cellStyle: {
      type: Object,
      default: function () {
        return {}
      }
    },
    headerCellStyle: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    statsCard
  },
  computed: {
    budgetRemainingClass: function () {
      let returnValue = 'finance-card-title'
      if (this.budgetInfo.Budget.BudgetedExpenses - this.budgetInfo.Budget.ActualExpenses < 0) {
        returnValue += ',text-red'
      }
      return returnValue
    },
    budgetRemaining: function () {
      return formatter.formatAsCurrency(this.budgetInfo.Budget.BudgetedExpenses - this.budgetInfo.Budget.ActualExpenses)
    },
    budgetSpent: function () {
      return formatter.formatAsCurrency(this.budgetInfo.Budget.ActualExpenses)
    },
    percentBudgetSpent: function () {
      return formatter.formatAsPercent(this.budgetInfo.Budget.ExpenseToBudget)
    },
    percentBudgetRemaining: function () {
      if (this.budgetInfo.Budget.ExpenseToBudget > 1) {
        return formatter.formatAsPercent(0)
      } else {
        return formatter.formatAsPercent(1 - this.budgetInfo.Budget.ExpenseToBudget)
      }
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
@media screen and (max-width: 1024px) {
  .finance-card-title {
    font-size: 24px;
  }
}
</style>
